import { styled } from 'styled-components';

import { LocationInput } from '#/components/LocationInput/LocationInput';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { SearchLocation } from '#/modules/search/types/SearchLocation';

import { usePageHeaderSearchInputsDesktopContext } from './DesktopSearchBarContext';

const Holder = styled.div`
  flex: 1;
  max-width: 258px;
`;

type Props = {
  searchLocation: SearchLocation | null;
  onChangeSearchLocation: (
    newSearchLocation: SearchLocation | undefined,
  ) => boolean;
};

export function DesktopSearchBarLocationInput({
  searchLocation,
  onChangeSearchLocation,
}: Props) {
  const { i18n } = useI18n();

  const { submit } = usePageHeaderSearchInputsDesktopContext();

  return (
    <Holder>
      <LocationInput
        affixVariant="transparent"
        styleVariant="contrast"
        hasRemoteOptions
        showLocationIcon
        showClearButton
        placeholder={i18n('Everywhere')}
        locationText={searchLocation?.text}
        id="page-header-desktop-search-location"
        onChange={(newLocation) => {
          // Avoid submitting twice - the LocationInput has a bug that triggers the onChange twice
          if (!onChangeSearchLocation(newLocation)) return;

          // Trigger search when search location changes
          submit({
            triggeredByRemoteLocationChange: Boolean(newLocation?.isRemote),
          });
        }}
      />
    </Holder>
  );
}
